import styles from "./Tagline.module.scss";
import MiscellaneousCheckmarkCircleFill from "../../../../../common/icons/MiscellaneousCheckmarkCircleFill.tsx";
import { ReactNode } from "react";
import { LightningIcon } from "./TaglineIcons.tsx";

export default function Tagline({
  children,
  iconType,
}: {
  children: ReactNode;
  iconType: "none" | "greenCheck" | "lightning";
}) {
  return (
    <div className={styles.tagline}>
      {iconType === "greenCheck" && (
        <MiscellaneousCheckmarkCircleFill className={styles.green} />
      )}
      {iconType === "lightning" && <LightningIcon />}
      {children}
    </div>
  );
}
